module.exports = __webpack_public_path__ + "static/media/016.62f9b47f.jpg";